import React from 'react'
import ABMember1 from '../../Images/HR/AdvisoryBoard/PitKumarShrestha.jpg'
import ABMember2 from '../../Images/HR/AdvisoryBoard/ArjunRajAdhikari.jpg'
import ABMember3 from '../../Images/HR/AdvisoryBoard/PitambarDahal.jpg'
import ABMember4 from '../../Images/HR/AdvisoryBoard/AjambarRai.jpg'
import ABMember5 from '../../Images/HR/AdvisoryBoard/HariPrasadGhimire.jpg'
import ABMember6 from '../../Images/HR/AdvisoryBoard/BhaktiPrasadSitaula.jpg'
import ABMember7 from '../../Images/HR/AdvisoryBoard/RamBahadurThapa.jpg'
import ABMember8 from '../../Images/HR/AdvisoryBoard/PuranRai.JPG'
import ABMember9 from '../../Images/HR/AdvisoryBoard/Balaram.jpg'
import ABMember10 from '../../Images/HR/AdvisoryBoard/PhadindraPaudel.jpg'
import ABMember11 from '../../Images/HR/AdvisoryBoard/Umesh.jpg'
import ABMember12 from '../../Images/HR/AdvisoryBoard/GangaPrasadGhimire.jpg'
import ABMember13 from '../../Images/HR/AdvisoryBoard/Bharati.jpg'
import Aos from 'aos'

const AdvisoryBoard = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    });

    const AdvisoryBoardList = [
        {
            id: '1',
            memName: 'पीतकुमार श्रेष्ठ',
            post: 'सदस्य',
            memImg: ABMember1
        },
        {
            id: '2',
            memName: 'अर्जुनराज अधिकारी ',
            post: 'सदस्य',
            memImg: ABMember2
        },
        {
            id: '3',
            memName: 'पीताम्बर दाहाल',
            post: 'सदस्य',
            memImg: ABMember3
        },
        {
            id: '4',
            memName: 'अजम्बर राई',
            post: 'सदस्य',
            memImg: ABMember4
        },
        {
            id: '5',
            memName: 'हरीप्रसाद घिमिरे',
            post: 'सदस्य',
            memImg: ABMember5
        },
        {
            id: '6',
            memName: 'भक्तिप्रसाद सिटौला',
            post: 'सदस्य',
            memImg: ABMember6
        },
        {
            id: '7',
            memName: 'रामबहादुर थापा',
            post: 'सदस्य',
            memImg: ABMember7
        },
        {
            id: '8',
            memName: 'पुरनकुमार राई',
            post: 'सदस्य',
            memImg: ABMember8
        },
        {
            id: '9',
            memName: 'बलराम पोखरेल',
            post: 'सदस्य',
            memImg: ABMember9
        },
        {
            id: '10',
            memName: 'फणिन्द्र पौडेल',
            post: 'सदस्य',
            memImg: ABMember10
        },
        {
            id: '11',
            memName: 'उमेश उप्रेती',
            post: 'सदस्य',
            memImg: ABMember11
        },
        {
            id: '12',
            memName: 'गंगाप्रसाद घिमिरे',
            post: 'सदस्य',
            memImg: ABMember12
        },
        {
            id: '13',
            memName: 'भारती बराल',
            post: 'सदस्य',
            memImg: ABMember13
        },
    ]

    return (
        <div className='main'>
            <div className='left-fixed'></div>
            <div className='container'>
                <div className='heading1' data-aos='fade-right'>
                    <div className='h2'>
                        <h2>कनकलक्ष्मी साकोस :: सल्लाहकार मण्डल</h2><hr />
                    </div>
                </div>
                <div className='president2' data-aos='fade-right'>
                    {AdvisoryBoardList.map((item, index) => {
                        return (
                            <div className='president2-body' key={index}>
                                <div className='president2-img'>
                                    <img src={item.memImg} alt='AdvisoryBoard' />
                                </div>
                                <div className='president2-detail'>
                                    <h2>{item.memName}</h2>
                                    <h3>{item.post}</h3>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className='right-fixed'></div>
        </div>
    )
}

export default AdvisoryBoard